
import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const paymentsKeyFactory = {
    // ================================
    // PAYMENTS LIST
    // ================================
    list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "payment",
        "list",
        filters,
    ],
    exportList: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "payment",
        "paymentExport",
        filters,
    ],
    // ================================
    // PAYMENT DETAILS
    // ================================
    details: (paymentId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "payment",
        "details",
        paymentId,
    ],  
    creditNoteDetails: (creditNoteId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "creditNote",
        "details",
        creditNoteId,
    ],  
    summary: (remoteUtilityId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "payment",
        "summary",
        remoteUtilityId,
    ],
    // ================================
    // PAYMENT SERVICES
    // ================================
    services: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "payment",
        "services",
        filters,
    ],
    consumerSearch: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "payment",
        "consumerSearch",
        filters,
    ],
    consumerMetaData: (consumerId: number, remoteUtilityId: number): [ModuleType, EntityType, ActionType, number, number] => [
        "cx",
        "payment",
        "consumerMetaData",
        consumerId,
        remoteUtilityId,
    ],
    creditNoteSummary: (remoteUtilityId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "creditNote",
        "summary",
        remoteUtilityId,
    ],
    latestBill: (remoteUtilityId: number, consumerId: number, consumerNo: string): [ModuleType, EntityType, ActionType, number, number, string] => [
        "cx",
        "payment",
        "latestBill",
        remoteUtilityId,
        consumerId,
        consumerNo,
    ],
    creditNotes: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "creditNote",
        "list",
        filters,
    ],
    createCreditNote: (remoteUtilityId: number, consumer: number, consumerNo: string): [ModuleType, EntityType, ActionType, number, number, string] => [
        "cx",
        "creditNote",
        "create",
        remoteUtilityId,
        consumer,
        consumerNo,
    ],
    creditNoteReasons:(remoteUtilityId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "creditNote",
        "reasons",
        remoteUtilityId,
    ],
    paymentReceivedStatusChoices: (remoteUtilityId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "payment",
        "receivedStatusChoices",
        remoteUtilityId,
    ],
    paymentPayTypeChoices: (remoteUtilityId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "payment",
        "payTypeChoices",
        remoteUtilityId,
    ],
    installments: (params: {
        remoteUtilityId: number;
        consumerId: number;
        consumerNo: string;
    }): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "payment",
        "installments",
        params,
    ],

     serviceOrderData: (params: {
       remote_utility_id: any;
    consumer_id:any;
    }): [ModuleType, EntityType, "serviceOrderData", any?] => [
        "cx",
        "payment",
        "serviceOrderData",
        params,
    ],
    paymentMethod: (params: {
        remoteUtilityId: number;
    }): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "payment",
        "paymentMethod",
        params,
    ],
    paymentChannelChoices:(
        remoteUtilityId: number
    ): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "payment",
        "paymentChannel",
        remoteUtilityId,
    ]
};